import { PermissionRow } from '@capturi/core'
export const getCrudPermissions = (): PermissionRow[] => {
  const rows: PermissionRow[] = [
    {
      name: 'Dashboards',
      key: 'editDashboard',
      description:
        'Permission to create, edit, and delete dashboards. Only users with this permission can access non-shared dashboards.',
      hidden: false,
    },
    {
      name: 'Trackers',
      key: 'editTracker',
      description: 'Permission to create, edit and delete trackers.',
      hidden: false,
    },
    {
      name: 'Master Trackers',
      key: 'editMasterTracker',
      description: 'Permission to create, edit, and delete Master Trackers.',
    },
    {
      name: 'Segments',
      key: 'editSegment',
      description: 'Permission to create, edit, and delete segments.',
    },
    {
      name: 'Library Folders and Snippets',
      key: 'editLibrary',
      description:
        'Permission to create, edit, and delete library folders and snippets.',
    },
  ]

  return rows
}
